import React from 'react';
import styled, { css } from 'styled-components';
import { t } from '@lingui/macro';
import { Button, Flex } from '@decisiv/ui-components';
import ClearNight from '@decisiv/iconix/lib/components/ClearNight';
import Lightbulb from '@decisiv/iconix/lib/components/Lightbulb';

import { useTheme, THEME_MODES } from '../../theme/ThemeProvider';

const ToggleButton = styled(Button)`
  ${({ $lit }) =>
    $lit &&
    css`
      && svg {
        color: var(--if-warning);
      }
    `}
`;

// Hidden until a Global Admin enables Themes Management.
export default function NightModeToggle() {
  const { enabled, mode, toggle } = useTheme();

  if (!enabled) return null;

  const isNight = mode === THEME_MODES.NIGHT;

  return (
    <Flex marginLeft={1} alignItems="center">
      <ToggleButton
        $lit={isNight}
        kind="secondary"
        variant="ghost"
        icon={isNight ? Lightbulb : ClearNight}
        aria-label={t`Night mode`}
        aria-pressed={isNight}
        onClick={toggle}
        data-testid="night-mode-toggle"
      />
    </Flex>
  );
}
